export enum MessageType {
  Success = 'success',
  Failure = 'failure',
  Notice = 'notice',
}

interface Message {
  id: string;
  message: string;
  messageType: MessageType;
  persist?: boolean;
  expiresAt: string;
}

export default Message;
